import React, { useMemo } from "react";
import { ServerPaginatedtable } from "../../../shared";
import { createColumnHelper } from "@tanstack/react-table";
import { useCostChangeHistory } from "../hooks";

export const CostChangeHistory = (props) => {
  const { recipeId } = props;

  const { costChangeHistoryQuery, tableState, tableHelpers } =
    useCostChangeHistory({
      recipeId,
    });

  const columnHelper = createColumnHelper();
  const columns = useMemo(
    () => [
      columnHelper.accessor("changed_at", {
        header: () => "Date & Time",
      }),
      columnHelper.accessor("changed_by", {
        header: () => "User",
      }),
      columnHelper.accessor("new_cost_exc_gst", {
        header: () => "Updated Cost (Ex GST)",
        cell: ({ getValue }) => {
          const value = getValue();
          return `$${typeof Number(value) === "number" ? Number(value).toFixed(3) : value}`;
        },
      }),
    ],
    [columnHelper],
  );

  return (
    <ServerPaginatedtable
      defaultData={costChangeHistoryQuery?.data?.history || []}
      columns={columns}
      isLoading={costChangeHistoryQuery.isLoading}
      headerText="Cost Change History"
      emptyMessage="No cost change history available."
      pagination={tableState.pagination}
      setPagination={tableHelpers.setPagination}
      sorting={tableState.sorting}
      setSorting={tableHelpers.setSorting}
      onSearchChange={tableHelpers.onSearchHandler}
      search={tableState.search}
      paginationProps={
        costChangeHistoryQuery?.data?.pagination || { total: 0, lastPage: 1 }
      }
      isInTab
      rightContent={<span></span>}
    />
  );
};
